<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading">
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>
      <div class="columns is-vcentered" v-else-if="requestsuccess">
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">account_balance</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />

              <h5 class="has-text-centered pb-20">قيمة رصيدك الحالي:</h5>

              <a class="button btn-align btn-hero is-default raised is-medium">
                <b>{{ balance }} دينار ليبي</b>
              </a>

              <hr />
            </div>
          </div>
          <div class="hero-foot has-text-centered mt-40 mt-40">
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered" v-else>
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4 pb-10">
                تم فشل ارسال طلب {{ requeststring }}
              </h1>

              <h1 class="subtitle is-5">{{ errormessage }}</h1>

              <!-- 
              <h1 class="subtitle is-5">رجاء المحاولة لاحقاً</h1>-->
              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      requestloading: true,
      requestsuccess: false,
      errormessage: "",
      balance: null,
      requestInfo: {
        Token: null,
        Id: null,
        AccountNo: null,
      },
    };
  },
  created() {
    var user = JSON.parse(localStorage.getItem("user"));

    this.requestInfo.Id = user[1];

    axios
      .get("customer/basicData/" + this.requestInfo.Id)
      .then((response) => {
        this.$root.kick(response.data.message);

        console.log(response.data);

        this.requestInfo.AccountNo = response.data.result.MainAccountNo;

        axios
          .post("account/balance/", this.requestInfo)
          .then((response) => {
             this.requestloading = !this.requestloading;
            if(response.data.status === 'success'){
              this.$root.kick(response.data.message);
              this.balance = response.data.balance;
              this.requestsuccess = true;
            }
            else{
              this.responseSuccess = false;
              this.errormessage = response.data.message
            }
            
          })
          .catch((error) => {
              this.responseSuccess = false;
              this.errormessage = response.data.message
          });
      })
      .catch((error) => {});

    let token = localStorage.getItem("token");
    this.requestInfo.Token = token;
    console.log(this.requestInfo);
  },
};
</script>
